/* eslint-disable prefer-arrow-callback,no-var,comma-dangle */
(function TV2dkHeader(window) {
  var windowWidth = null;
  var resizeTimer = null;
  var handleResize = null;
  var handleClick = null;
  var localNav = document.querySelector('.tc_header__local');
  var localNavButton = null;
  var localNavDropdown = null;

  const xhr = new XMLHttpRequest();
  var htmlElement = document.documentElement;
  var navigationContainer = document.querySelector('#navigation-overlay');
  var menuButton = document.querySelector(
    '[aria-controls="navigation-overlay"]',
  );
  var navigationUrlElement = document.querySelector(
    '[data-navigation-overlay-url]',
  );

  function scriptStringToNode(htmlString) {
    var div = document.createElement('div');
    var scriptEl;
    div.innerHTML = htmlString.trim();

    // div.firstChild trick doesn't work for <script> elements
    // script has to be created strictly using document.createElement
    if (div.firstChild && div.firstChild.tagName === 'SCRIPT') {
      scriptEl = document.createElement('script');
      scriptEl.src = div.firstChild.src;
      scriptEl.async = div.firstChild.async;
      return scriptEl;
    }
    return null;
  }

  function trackEvent(event) {
    try {
      window.tv2.analyticsUtils.trackEvent(event);
    } catch (_) {
      console.warn('unable to track event', { event });
    }
  }

  // GLOBAL NAVIGATION
  function buttonEventListener(e) {
    xhr.open('GET', navigationUrlElement.dataset.navigationOverlayUrl);
    // responseType json does not work on ie 11.
    xhr.responseType = 'text';
    xhr.send();

    htmlElement.classList.toggle('js-header__overlay');
    if (htmlElement.classList.contains('js-header__overlay')) {
      menuButton.setAttribute('aria-expanded', 'true');
      trackEvent('tv2dk.menu.open');
    } else {
      menuButton.setAttribute('aria-expanded', 'false');
      trackEvent('tv2dk.menu.close');
    }
    e.preventDefault();
  }

  // Show navigation container on click (Will be empty until async load is complete)
  if (navigationUrlElement) {
    menuButton.addEventListener('click', buttonEventListener);
  }

  // If the xhrRequest errors out, remove event listener and overlay so the user cannot get stuck.
  function handleError() {
    htmlElement.classList.remove('js-header__overlay');
    menuButton.removeEventListener('click', buttonEventListener);
  }

  function isJson(input) {
    let item = typeof input !== 'string' ? JSON.stringify(input) : input;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === 'object' && item !== null) {
      return true;
    }

    return false;
  }

  // Load full page navigation overlay
  xhr.onerror = handleError;
  xhr.onload = function handleNavigationResponse() {
    if (this.status === 200 && this.response) {
      // This if will ensure that the component backwards compatible until navigation services is deployed.
      // Can be removed when TV2DK-3245 in navigation services is deployed.
      if (isJson(this.response)) {
        const json = JSON.parse(this.response);
        navigationContainer.innerHTML = json.html;
        Array.prototype.forEach.call(json.script, function mapScripts(script) {
          const scriptNode = scriptStringToNode(script);
          if (scriptNode) {
            document.body.appendChild(scriptNode);
          }
        });
      } else {
        navigationContainer.innerHTML = this.response;
      }
    } else {
      handleError();
      menuButton.click();
    }
  };

  // LOCAL NAVIGATION
  if (window.tv2localNav && window.tv2localNav.wrl) {
    window.removeEventListener('resize', window.tv2localNav.wrl);
  }

  if (localNav && window.tv2localNav && window.tv2localNav.lcl) {
    localNav.removeEventListener('click', window.tv2localNav.lcl);
  }
  if (localNav && localNav.classList) {
    localNav.classList.remove('tc_header__local--dropdown');
  }

  // eslint-disable-next-line no-param-reassign, no-multi-assign
  window.tv2localNav = handleResize = function _handleResize() {
    var widthOfMoreBtn = 65; // How many pixels we need to fit the More btn
    var fuzz = 0; // If we are over the available width by less than this, it's still okay

    var availableWidth;
    var sectionName;
    var localLinks;
    var i;
    var link;
    var remainingSpace;
    var overflowItem;
    var overflowList;
    var overflowLabel;
    var overflowedItems;

    if (!localNav) return;

    availableWidth = localNav.offsetWidth;

    sectionName = localNav.querySelector('.tc_heading');
    if (sectionName) {
      availableWidth -= sectionName.offsetWidth;
    }

    overflowItem = localNav.querySelector('.js-tc_header__local__more');
    if (overflowItem) {
      overflowedItems = Array.prototype.slice.call(
        overflowItem.querySelectorAll('.tc_header__list__local__item'),
      );
      for (i = 0; i < overflowedItems.length; i += 1) {
        overflowItem.parentNode.insertBefore(overflowedItems[i], overflowItem);
      }
      overflowItem.parentNode.removeChild(overflowItem);
      overflowItem = null;
    }

    localLinks = Array.prototype.slice.call(
      localNav.querySelectorAll('.tc_header__list__local__item'),
    );

    // eslint-disable-next-line max-len
    if (
      availableWidth + fuzz <=
      localLinks.reduce(function _widthReducer(acc, cur) {
        return acc + cur.offsetWidth;
      }, 0)
    ) {
      remainingSpace = availableWidth - widthOfMoreBtn;
      for (i = 0; i < localLinks.length; i += 1) {
        link = localLinks[i];
        remainingSpace -= link.offsetWidth;
        if (remainingSpace <= 0) {
          if (!overflowList) {
            overflowItem = window.document.createElement('li');
            overflowItem.className =
              'tc_header__list__local__item js-tc_header__local__more';
            overflowLabel = window.document.createElement('button');
            // eslint-disable-next-line max-len
            overflowLabel.className =
              'tc_header__list__local__link tc_header__list__local__more js-tc_header__local__trigger';
            overflowLabel.setAttribute('aria-expanded', false);
            overflowLabel.setAttribute('aria-controls', 'js-local__dropdown');
            overflowLabel.setAttribute('aria-label', 'Vis flere menupunkter');
            overflowLabel.innerText = 'Mere...';
            overflowItem.appendChild(overflowLabel);
            overflowList = window.document.createElement('ul');
            overflowList.className = 'tc_header__list__local__dropdown';
            overflowList.setAttribute('hidden', 'hidden');
            overflowList.setAttribute('id', 'js-local__dropdown');
            overflowItem.appendChild(overflowList);
            link.parentNode.insertBefore(overflowItem, link);
          }
          overflowList.appendChild(link);
        }
      }
    }
  };

  handleClick = function _handleClick() {
    localNav.classList.toggle('tc_header__local--dropdown');
    localNavButton = localNav.querySelector('.tc_header__list__local__more');
    localNavDropdown = localNav.querySelector(
      '.tc_header__list__local__dropdown',
    );
    if (localNav.classList.contains('tc_header__local--dropdown')) {
      localNavButton.setAttribute('aria-expanded', true);
      localNavButton.setAttribute('aria-label', 'Vis færre menupunkter');
      localNavDropdown.removeAttribute('hidden');
    } else {
      localNavButton.setAttribute('aria-expanded', false);
      localNavButton.setAttribute('aria-label', 'Vis flere menupunkter');
      localNavDropdown.setAttribute('hidden', 'hidden');
    }
  };

  function domready() {
    localNav = document.querySelector('.tc_header__local');

    if (!localNav) return;

    // eslint-disable-next-line no-param-reassign
    window.tv2localNav.wrl = function _resize() {
      if (window.innerWidth !== windowWidth) {
        if (resizeTimer) {
          window.clearTimeout(resizeTimer);
        }
        windowWidth = window.innerWidth;
        resizeTimer = window.setTimeout(handleResize, 300);
      }
    };
    window.addEventListener('resize', window.tv2localNav.wrl);

    // eslint-disable-next-line no-param-reassign
    window.tv2localNav.lcl = function _click(event) {
      if (
        event.target &&
        event.target.classList &&
        event.target.classList.contains('js-tc_header__local__trigger')
      ) {
        handleClick(event);
      }
    };
    localNav.addEventListener('click', window.tv2localNav.lcl);

    handleResize();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', domready);
  } else {
    domready();
  }
})(window);
